/**
 * Sort sections by source_tag group order, then by section_number (natural sort).
 * Order: Original Contract → Addendum 1 → Addendum 2 → ... → untagged
 */

function sourceTagOrder(tag) {
  if (!tag || tag === 'Original Contract') return 0;
  const m = tag.match(/(\d+)/);
  return m ? parseInt(m[1], 10) : 999;
}

function naturalSortKey(sectionNumber) {
  if (!sectionNumber) return [999, '', ''];
  // Extract leading part like "Section 1" or "Section A" or just "1" or "A"
  const parts = [];
  const regex = /(\d+)|([a-zA-Z]+)/g;
  let match;
  while ((match = regex.exec(sectionNumber)) !== null) {
    if (match[1] !== undefined) {
      parts.push([0, parseInt(match[1], 10), '']);
    } else {
      parts.push([1, 0, match[2].toLowerCase()]);
    }
  }
  return parts.length > 0 ? parts : [[999, 0, '']];
}

function compareNatural(a, b) {
  const keysA = naturalSortKey(a);
  const keysB = naturalSortKey(b);
  const len = Math.max(keysA.length, keysB.length);
  for (let i = 0; i < len; i++) {
    const ka = keysA[i] || [999, 0, ''];
    const kb = keysB[i] || [999, 0, ''];
    // Compare type (numeric=0 first, alpha=1 second)
    if (ka[0] !== kb[0]) return ka[0] - kb[0];
    // Compare numeric parts
    if (ka[1] !== kb[1]) return ka[1] - kb[1];
    // Compare alpha parts
    if (ka[2] !== kb[2]) return ka[2] < kb[2] ? -1 : 1;
  }
  return 0;
}

export function sortSections(sections) {
  if (!sections || !Array.isArray(sections)) return sections || [];
  return [...sections].sort((a, b) => {
    const tagA = sourceTagOrder(a.source_tag);
    const tagB = sourceTagOrder(b.source_tag);
    if (tagA !== tagB) return tagA - tagB;
    return compareNatural(a.section_number || '', b.section_number || '');
  });
}

/**
 * Group sections by source_tag for display with headers.
 * Returns array of { tag: string, sections: Section[] }
 */
export function groupSectionsByTag(sections) {
  const sorted = sortSections(sections);
  const groups = [];
  let currentTag = null;
  let currentGroup = null;
  for (const s of sorted) {
    const tag = s.source_tag || 'Original Contract';
    if (tag !== currentTag) {
      currentTag = tag;
      currentGroup = { tag, sections: [] };
      groups.push(currentGroup);
    }
    currentGroup.sections.push(s);
  }
  return groups;
}

/** Standard source_tag options for dropdowns */
export const SOURCE_TAG_OPTIONS = [
  'Original Contract',
  'Addendum 1',
  'Addendum 2',
  'Addendum 3',
  'Addendum 4',
  'Addendum 5',
  'Addendum 6',
  'Addendum 7',
  'Addendum 8',
  'Addendum 9',
  'Addendum 10',
];
